
export function storageDelete(key) {
    if (!isElectron()) {
        return
    }
    window.top.postMessage(
        {
            typ: 'storage',
            op: "delete",
            keyName: key
        }, "*");
}

export function storageSet(key, value) {
    if (!isElectron()) {
        return
    }
    window.top.postMessage(
        {
            typ: 'storage',
            op: "set",
            keyName: key,
            value: value
        }, "*");
}

export function storageClear() {
    if (!isElectron()) {
        return
    }
    window.top.postMessage(
        {
            typ: 'storage',
            op: "clear"
        }, "*");
}

export function cookieDelete(key) {
    if (!isElectron()) {
        return
    }
    window.top.postMessage(
        {
            typ: 'cookie',
            op: "delete",
            keyName: "key"
        }, "*");
}

function isElectron() {
    let userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf(' electron/') > -1;
}
